import { resolveDiscounts, resolveDiscount, resolveMembershipDiscount } from './resolvers/discount.resolver';

export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app.admin.discounts', {
      url: '/discounts',
      component: 'discountList',
      resolve: {
        discounts: resolveDiscounts(1, 20),
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.discount-add', {
      url: '/discounts/create',
      component: 'discountSave',
      resolve: {
        title: () => 'Create a promo code'
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.discount-edit', {
      url: '/discounts/:discount/update?tab',
      component: 'discountSave',
      resolve: {
        title: () => 'Update a promo code',
        discount: resolveDiscount()
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.membershipDiscount', {
      url: '/membership-discounts',
      component: 'membershipDiscount',
      resolve: {
        title: () => 'Membership Discount',
        details: resolveMembershipDiscount()
      },
      roles: [ 'manager' ]
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/discount.routes.js